import { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import translations from '../utils/translations';

// Custom hook to get translations
const useTranslation = () => {
  const { language } = useContext(LanguageContext);
  
  // Function to get a translation by key
  const t = (key) => {
    // Split the key by dots to access nested properties
    const keys = key.split('.');
    
    // Start with the translations for the current language
    let translation = translations[language];
    
    // Navigate through the nested properties
    for (const k of keys) {
      if (translation && translation[k]) {
        translation = translation[k];
      } else {
        // If the translation doesn't exist, fall back to English
        let fallback = translations['en'];
        for (const k of keys) {
          if (fallback && fallback[k]) {
            fallback = fallback[k];
          } else {
            return key; // Return the key if no translation is found
          }
        }
        return fallback;
      }
    }
    
    return translation;
  };
  
  return { t, language };
};

export default useTranslation;
